import { useState, FC } from "react";
import { TbChevronRight } from "react-icons/tb";
import { Link } from "react-router-dom";

interface Props {
  question: string;
  answer: string;
  cta?: { label: string; to: string };
}

export const FaqComponent: FC<Props> = ({ question, answer, cta }) => {

  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => setIsOpen((prev) => !prev);

  return (
    <div className="flex flex-col gap-3 border-b border-[#E5EAF0] pb-6">
      <div
        className="flex justify-between gap-2 items-center cursor-pointer"
        onClick={toggleAnswer}
      >
        <p className="text-blueShades-4 text-lg font-satoshi font-semibold">
          {question}
        </p>
        <div>
          <TbChevronRight
            size={24}
            color="#112F5D"
            className={`transform transition-transform duration-300 ${
              isOpen ? "rotate-90" : "rotate-0"
            }`}
          />
        </div>
      </div>
      {isOpen && (
        <p className="text-ashShade-16 text-base font-SatoshiMedium">
          {answer}
          {cta && (
            <>
              {" "}
              <Link to={cta.to} className=" text-bblue">
                {cta.label}
              </Link>
              .
            </>
          )}
        </p>
      )}
    </div>
  );
};
